/**
 * Manage global libraries like jQuery or THREE from the webpack.mix.js file
 */
// import $ from 'jquery';

// Import template js assets


// Import custom modules
import App from './modules/App.js';
import BsDatePicker from './modules/BootstrapDatepicker';
// import SwiperCarousel from './modules/SwiperCarousel';
// import CF7response from './modules/CF7response';

// Instantiate
new App();
new BsDatePicker();
// new SwiperCarousel();
// new CF7response();
